import createAction from 'modules/auth/actions';
import { redirectLinks } from '../constants/redirectLinks';

export const SET_DEEP_LINK = createAction('SET_DEEP_LINK');
export const RESET_DEEP_LINK = createAction('RESET_DEEP_LINK');

export const setDeepLink = (link) => (dispatch, getState) => {
  const state = getState();
  const search = state.router.location.search;
  const params = new URLSearchParams(search);
  const redirect = params.get('redirect');

  const redirectLink = redirectLinks[redirect];

  if ((!redirect || !redirectLink) && !link) return;

  dispatch({
    type: SET_DEEP_LINK,
    deepLink: redirectLink || link,
    search,
  });
};

export const setCustomDeepLink = (link, search) => ({
  type: SET_DEEP_LINK,
  deepLink: link,
  search,
});

export const resetDeepLink = () => ({ type: RESET_DEEP_LINK });
